import { ComputerDesktopIcon, DevicePhoneMobileIcon } from "@heroicons/react/24/outline";
import type { Interaction } from "@/types";
import { interactionStatusLabel, viewportLabel } from "./helpers";

type ViewportSwitchProps = {
  interactions: Interaction[];
  onSelect: (interaction: Interaction) => void;
  selectedInteractionId: string;
};

export default function ViewportSwitch({ interactions, onSelect, selectedInteractionId }: ViewportSwitchProps) {
  if (interactions.length < 2) {
    return null;
  }

  return (
    <div className="mb-4">
      <div className="flex flex-col gap-3 sm:flex-row">
        {interactions.map((interaction) => {
          const selected = interaction.id === selectedInteractionId;

          return (
            <button
              key={interaction.id}
              type="button"
              className={`relative flex min-w-0 flex-1 cursor-pointer items-center justify-between rounded-lg px-4 py-2 transition-all duration-200 ease-in-out ${
                selected
                  ? "bg-white text-primary shadow-md ring-2 ring-primary/20"
                  : "bg-gray-50 text-gray-600 hover:bg-gray-100 hover:text-gray-900"
              }`}
              onClick={() => onSelect(interaction)}
            >
              <span className="flex items-center">
                <ViewportIcon viewport={interaction.viewport} />
                <span className="whitespace-nowrap text-base font-semibold">{viewportLabel(interaction.viewport)}</span>
              </span>
              <span className="text-sm text-gray-500">{interactionStatusLabel(interaction)}</span>
              {selected ? <span className="absolute -right-1 -top-1 h-2 w-2 rounded-full bg-primary" /> : null}
            </button>
          );
        })}
      </div>
    </div>
  );
}

function ViewportIcon({ viewport }: { viewport: string | null }) {
  const Icon = viewport === "mobile" ? DevicePhoneMobileIcon : ComputerDesktopIcon;

  return <Icon className="mr-2 h-5 w-5" aria-hidden="true" />;
}
